
import React from 'react'
import { Select, SelectProps } from 'antd';
import { activeStatusMap } from '../FilterFullPromotion/service';

export const activeStatusString = {
  toBeStart: 'start', // 未开始
  processing: 'doing', // 进行中
  end: 'end', // 已结束
}

// Ai Start
export const activeStatusStringMap = {
  [activeStatusString.toBeStart]: '未开始',
  [activeStatusString.processing]: '进行中',
  [activeStatusString.end]: '已结束',
}
// Ai End

export const ValueType = {
  string: 'string',
  number: 'number',
}


export interface FilterActivityStatusProps extends SelectProps {
  valueType?: string;
}

export const FilterActivityStatus = (props: FilterActivityStatusProps) => {
  const { placeholder = '活动状态', valueType, mode, ...reset } = props;
  const statusData = valueType == ValueType.number ?activeStatusMap : activeStatusStringMap;
  const options = Object.entries(statusData).map(([value, label]) => ({ label, value }))
  
  return (
    <Select
      style={{ width: '100%' }}
      mode={mode}
      options={options}
      placeholder={placeholder}
      {...reset}
    />
  )
}